

export default async (to, from, next) => {
  var token = await localStorage.getItem("gamingToken") || '';
  // const agentCode = await localStorage.getItem("agentCode") || "guest";
  // var correctedPath = to.path.replace('guest', `${agentCode}`);
  // var path = to.path.split('/')[0];
  // var correctedPath = to.path.replace(path, `${agentCode}`);
  // console.log(correctedPath);
  // console.log(to.path);
  // if (to.path == correctedPath) {
  if (to.meta.requiresAuth) {
    if (token.length > 0) {
      next();
    } else {
      next('/web');
    }
  } else {
    next();

  }
  // } else {
  //   next({ path: correctedPath, replace: false });

  // }

};
